import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { hasAnyPermission } from '../../utils/permissions';

// Guards a route by both authentication and permission - unlike ProtectedRoute,
// which only checks "is logged in", this blocks direct URL access for users
// who lack the required permission, matching the sidebar's visibility rules.
const PermissionRoute = ({ children, anyOf }) => {
  const { isAuthenticated, user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!hasAnyPermission(user, anyOf)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PermissionRoute;
